import { ChevronRight } from '@mui/icons-material'
import { FormControlLabel } from '@mui/material'
import imageNotSupported from 'assets/icons/imageNotSupported.svg'
import classNames from 'classnames'
import { orderApiSpace } from 'feature/productOrder/namespaces/orderApiSpace'
import { orderFormSpace } from 'feature/productOrder/namespaces/orderFormSpace'
import { ChangeEvent, MouseEventHandler, useState } from 'react'
import { FC } from 'react'
import { useAppSelector } from 'store/hooks'
import { Checkbox, Collapse } from 'ui'
import { LoaderInCentalPosition } from 'widget'

import style from './ProductOrderCard.module.scss'

interface IProductOrderCard {
  item: orderApiSpace.ProductType
  toggleActive: (arg0: orderApiSpace.ProductType) => void
}

// шаг 1
// выбор продукта
// -> карточка продукта
export const ProductOrderCard: FC<IProductOrderCard> = ({
  item,
  toggleActive,
}) => {
  const [productImg, setProductImg] = useState<string>(item.iconUrl)
  const [isImgaeLoaded, setImageLoaded] = useState<boolean>(false)
  const [isImageLoading, setImageLoading] = useState<boolean>(true)
  const currentEditForm = useAppSelector(
    state => state.orderForm.currentEditForm,
  )
  const products: orderFormSpace.Product[] = useAppSelector(
    state => state.orderForm.forms[currentEditForm].products,
  )

  const productsHas = (num: number) =>
    products?.some(current => current.id === num)

  const [count, setCount] = useState<number>(
    item.children?.list.filter(childItem => productsHas(childItem.id)).length ||
      0,
  )
  const [isActive, setActive] = useState<boolean>(
    productsHas(item.id) ||
      item.children?.list.some(childItem => productsHas(childItem.id)) ||
      false,
  )

  const [isOpened, setOpened] = useState<boolean>(false)

  const handleOpen = () => {
    setOpened(!isOpened)
  }

  const handleClick: MouseEventHandler<HTMLDivElement> = () => {
    if (item.children) {
      handleOpen()
      return
    }
    toggleActive(item)
    setActive(!isActive)
  }

  const handleActive: MouseEventHandler<HTMLLabelElement> = e => {
    e.stopPropagation()
  }

  const handleChange = (
    e: ChangeEvent<HTMLInputElement>,
    current: orderApiSpace.ProductType,
  ) => {
    toggleActive(current)
    if (e.currentTarget.checked) {
      setCount(prev => prev + 1)
    } else {
      setCount(prev => prev - 1)
    }
    setActive(e.currentTarget.checked)
  }

  const onErrorImg = () => {
    setProductImg(imageNotSupported)
  }

  const onLoadImg = () => {
    setImageLoaded(true)
    setImageLoading(false)
  }

  return (
    <section
      className={classNames(style.productOrderCard, {
        [style.productCardActive]: count >= 1 || isActive,
      })}
    >
      <div
        className={style.productInf}
        onClick={handleClick}
        data-testid={`product-card-${item.id}`}
      >
        <div className={style.productInfRight}>
          <div className={style.imgWrapper}>
            {isImageLoading && <LoaderInCentalPosition />}
            <img
              className={classNames(
                style.productImg,
                isImgaeLoaded && style.productImgVisible,
              )}
              src={productImg}
              alt={item.name}
              defaultValue={imageNotSupported}
              onError={onErrorImg}
              onLoad={onLoadImg}
              loading='lazy'
            />
          </div>

          <span className={classNames('default-text', style.productName)}>
            {item.name}
          </span>
        </div>
        {item.children && (
          <button
            type='button'
            className={classNames(style.dropDownBtn, {
              [style.dropDownBtnActive]: isOpened,
            })}
            onClick={handleOpen}
            data-testid={`product-card-expand-${item.id}`}
          >
            <ChevronRight />
          </button>
        )}
      </div>
      {item.children && (
        <Collapse in={isOpened}>
          <div className={style.propsWrapper}>
            {item.children.list.map(childItem => (
              <FormControlLabel
                key={childItem.id}
                onClick={handleActive}
                control={
                  <Checkbox
                    onChange={e => {
                      handleChange(e, childItem)
                    }}
                    checked={
                      products?.some(current => current.id === childItem.id) ||
                      false
                    }
                    data-testid={`product-card-child-${childItem.id}`}
                  />
                }
                label={childItem.name}
              />
            ))}
          </div>
        </Collapse>
      )}
    </section>
  )
}
